import { useState, useEffect } from "react";
import { API_BASE } from "../config";
export default function Overview() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  const [range, setRange] = useState("week"); // default: minggu
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  const iconColors = [
    "bg-blue-100 text-blue-600",
    "bg-green-100 text-green-600",
    "bg-purple-100 text-purple-600",
    "bg-pink-100 text-pink-600",
    "bg-yellow-100 text-yellow-600",
    "bg-indigo-100 text-indigo-600",
    "bg-teal-100 text-teal-600",
    "bg-orange-100 text-orange-600",
    "bg-red-100 text-red-600",
    "bg-cyan-100 text-cyan-600",
  ];

  useEffect(() => {
    setLoading(true);

    let url = `${API_BASE}/api/overview`;
    if (start && end) {
      url += `?start=${start}&end=${end}`;
    } else if (range) {
      url += `?range=${range}`;
    }

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setLocations(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching overview:", err);
        setLoading(false);
      });
  }, [range, start, end]);

  const handleDateFilter = () => {
    if (!start || !end) {
      alert("Pilih tanggal mulai dan akhir!");
      return;
    }
    setRange(""); // kosongkan supaya backend pakai start–end
  };

  return (
    <div className="p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-4">
        <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
          🏢 Location Overview
        </h2>

        <div className="flex items-center gap-3">
          {/* Pilihan Range */}
          <select
            value={range}
            onChange={(e) => {
              setRange(e.target.value);
              setStart("");
              setEnd("");
            }}
            className="border rounded-lg px-3 py-2"
          >
            <option value="day">Hari ini</option>
            <option value="week">7 Hari Terakhir</option>
            <option value="month">30 Hari Terakhir</option>
          </select>

          {/* Date Range Picker */}
          <input
            type="date"
            value={start}
            onChange={(e) => setStart(e.target.value)}
            className="border rounded-lg px-2 py-2"
          />
          <span>-</span>
          <input
            type="date"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
            className="border rounded-lg px-2 py-2"
          />
          <button
            onClick={handleDateFilter}
            className="bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            Filter
          </button>
        </div>
      </div>

      {loading ? (
        <p className="text-gray-500">Loading...</p>
      ) : locations.length === 0 ? (
        <p className="text-gray-500">Belum ada data lokasi</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {locations.map((loc, index) => {
            const iconClass = iconColors[index % iconColors.length];

            return (
              <div
                key={loc.id}
                className="bg-white rounded-2xl shadow-lg p-5 border hover:shadow-xl transition duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full shadow-md mb-4 ${iconClass}`}
                  >
                    <span className="text-2xl">📍</span>
                  </div>

                  <h3 className="text-lg font-bold text-gray-800">{loc.nama}</h3>
                  <p className="text-sm text-gray-600 mb-3">{loc.deskripsi}</p>

                  <div className="bg-gray-100 text-gray-800 rounded-lg px-3 py-1 text-sm font-semibold shadow-sm">
                    {loc.visits} kunjungan
                  </div>

                  {loc.lastUser ? (
                    <p className="mt-2 text-xs text-gray-500 italic">
                      Terakhir: {loc.lastUser} ({loc.lastTime})
                    </p>
                  ) : (
                    <p className="mt-2 text-xs text-gray-400 italic">
                      Belum ada kunjungan
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
